export class EnvioComision {
    claveEmpleado: string;
    fechaColocacion: string;
    fechaPago: string;
    montoColocacion: number;
    montoComision: number;
}